import { AcmidmAuthModule, AcmidmConfiguration } from '@anb/ng-auth';
import { ROUTE } from '@core/models/route';
import { ENVIRONMENT } from 'environments/environment';

function authConfig(): AcmidmConfiguration {
  return {
    loginUrl: `${ENVIRONMENT.API_BASE_PATH}${ENVIRONMENT.loginPath}`,
    logoutUrl: `${ENVIRONMENT.API_BASE_PATH}${ENVIRONMENT.logoutPath}`,
    tokenUrl: `${ENVIRONMENT.API_BASE_PATH}${ENVIRONMENT.tokenPath}`,
    policiesUrl: `${ENVIRONMENT.API_BASE_PATH}${ENVIRONMENT.policiesPath}`,
    accessDeniedPath: ROUTE.FORBIDDEN,
    appName: 'AFM-BO',
    includeUrls: [ENVIRONMENT.API_BASE_PATH],
    excludeUrls: [ENVIRONMENT.API_BASE_PATH + ENVIRONMENT.loginPath, ENVIRONMENT.API_BASE_PATH + ENVIRONMENT.tokenPath],
  };
}

export const AuthImports = [AcmidmAuthModule.forRoot(authConfig)];
